import BaffleButton from '@nordinvestments/nord-storybook/dist/components/BaffleButton'
import ScrollTransition from '@nordinvestments/nord-storybook/dist/components/ScrollTransition'
import classNames from 'classnames'
import React from 'react'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import BaseSection from '../../../BaseSection'
import HeroShapesVideo from '../../../HeroShapesVideo'
import OnboardingLink from '../../../OnboardingLink'

import mp4Video from './media/pension.mp4'
import posterSrc from './media/pension.png'
import webmVideo from './media/pension.webm'
import styles from './PensionHero.module.scss'

const PensionHero = () => (
  <BaseSection.Hero
    backgroundClass={classNames('bg-nord-gradient', styles.pensionHero)}
    withCut
  >
    <Row>
      <Col
        xs={12}
        lg={5}
        className="offset-lg-1 mt-4 mt-lg-0 my-lg-auto text-center text-lg-left"
      >
        <BaseSection.Header.HeroTop className="text-white" scrollReveal>
          Pension
        </BaseSection.Header.HeroTop>
        <BaseSection.Header.Base
          className="text-white"
          scrollReveal
          isHeroHeader
        >
          Et Bedre hjem til din pensionsopsparing
        </BaseSection.Header.Base>
        <BaseSection.Text scrollReveal>
          Start eller flyt din pension og undgå omkostningerne der æder din
          pensionsopsparing op. Start med en gratis investeringsplan til din
          pension.
        </BaseSection.Text>
        <ScrollTransition.Item>
          <OnboardingLink
            component={BaffleButton}
            variant="success"
            path="pension"
          >
            Gratis investeringsplan
          </OnboardingLink>
        </ScrollTransition.Item>
      </Col>
      <Col xs={12} lg={5} className="mt-5 mt-lg-0">
        <HeroShapesVideo
          variant="C"
          mp4Video={mp4Video}
          posterSrc={posterSrc}
          webmVideo={webmVideo}
        />
      </Col>
    </Row>
  </BaseSection.Hero>
)

export default PensionHero
